import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DynamicComponentComponent } from 'app/modules/admin/dynamic-component/dynamic-component.component';
import { DrakeGridComponent } from 'app/drake-components/drake-grid/drake-grid.component';
import { MatIconModule } from '@angular/material/icon';
import { ChartsModule } from "@progress/kendo-angular-charts";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { SharedService } from 'app/services/shared.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageService } from 'app/services/page.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { DrakeCustomScriptsService } from 'app/services/drake-custom-scripts.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'd',
  standalone: true,
  templateUrl: './drake-scope-grid.component.html',
  styleUrls: ['./drake-scope-grid.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    DynamicComponentComponent,
    DrakeGridComponent,
    CommonModule,
    HttpClientModule,
    ChartsModule,
    MatIconModule,
    InputsModule,]
})
export class DrakeScopeGridComponent implements OnInit,OnDestroy {
  public pageData: any;
  public baseData: any = {};
  public viewCode: string = '';
  public filter: string = '{}';
  public template: string = null;
  public sort: string = '{}';
  public commandName: string = 'READ';
  public scope: string = '';
  private subscription:Subscription;

  constructor(
    private sharedService: SharedService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private pageService: PageService,
    private drakeShared: DrakeSharedService,
    private drakeScripts: DrakeCustomScriptsService) {
    this.setGridConfig();


    this.subscription = this.router.events.subscribe(event =>{
      if (event instanceof NavigationEnd){
         console.log(event.url)
         this.setGridConfig();
      }
   })

  }
  ngOnInit(): void {
    /*this.router.events.subscribe((val) => {
      console.log(val)
      if (val instanceof NavigationEnd) {
        this.setGridConfig();
      }
    })*/

  }

  setGridConfig() {
    this.drakeShared.currentBaseData = this.baseData;

    this.route.params.subscribe(params => {

      this.pageService.getPageByUrl(`d/${params?.['scope']}`).subscribe((result: any) => {
        this.pageData = result;
        this.drakeShared.currentPageData = result;
        const urlParams = new URLSearchParams(window.location.search);
        const filter = urlParams.get('filter') || '{}';
        this.filter = this.decodeJSONString(filter);
        const sort = urlParams.get('sort') || '{}';
        this.sort = this.decodeJSONString(sort);
        this.commandName = 'READ';
        this.scope = params['scope'].toUpperCase();
        this.viewCode = params['viewCode'] ? params['viewCode'].toUpperCase() : this.scope + '.DEFAULT';
        this.template = urlParams.get('template') || null;
        var drakeScripts = this.drakeScripts;
        this.drakeShared.currentPageData.pageScripts.forEach(s => {

          eval('drakeScripts[s.scriptCode] = function(args) {' + s.scriptContent + '}');
        });
      });
    })
  }

  decodeJSONString(str: string): string {
    try {
      const decodedStr = str.replace(/\\\"/g, '"');
      const parsedJSON = JSON.parse(decodedStr);
      return JSON.stringify(parsedJSON);
    } catch (e) {
      console.error('Invalid JSON string:', str);
      return '{}'; // Fallback to an empty object if parsing fails
    }
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
